//styles
import { useMemo } from "react";
import styles from "./primaryButton.module.scss";
import { ButtonPropsType, ButtonType } from "./types";
import classNames from "classnames";
import Loading from "../loading";

const PrimaryButton = ({
  size,
  rightIcon,
  leftIcon,
  text,
  onPress,
  border,
  buttonType = ButtonType.PRIMARY,
  loading,
  ...otherProps
}: ButtonPropsType) => {
  const buttonstyle = useMemo((): any => {
    switch (buttonType) {
      case ButtonType.DARK:
        return styles.dark_container;
      case ButtonType.BORDER:
        return styles.border_container;
      case ButtonType.DISABLED:
        return styles.disabled_container;
      case ButtonType.SECONDARY:
        return styles.secondary_container;
      default:
        return styles.container;
    }
  }, [buttonType]);

  return (
    <button
      className={classNames(buttonstyle, styles["relative"])}
      {...otherProps}
      onClick={onPress}
    >
      {loading && (
        <div className={classNames(styles["loading-overlay"])}>
          <Loading />
        </div>
      )}
      <>{leftIcon && leftIcon}</>
      {text && (
        <p
          className={classNames(
            styles["title"],
            rightIcon ? styles["mr-8"] : ""
          )}
          style={size ? { fontSize: size } : {}}
        >
          {text}
        </p>
      )}
      <>{rightIcon && rightIcon}</>
    </button>
  );
};

export default PrimaryButton;
